/*
 * @Author: your name
 * @Date: 2019-11-04 16:12:24
 * @LastEditTime: 2019-11-06 10:36:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \shendu-h5\src\common\isMp.js
 */
import { isMiniProgamme } from '@/common/util.js'
export default {
  data() {
    return {
      inMiniProgram: false
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // isMiniProgamme().then(res => {
    //   this.inMiniProgram = !res
    // })
  },
  activated () {
    this.init()
  },
  methods: {
    init() {
      let _this = this
      isMiniProgamme().then(res => {
        _this.inMiniProgram = res
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/common/isMp.js